/**
 * ProgressBar
 * 3-step progress indicator shown on all survey pages.
 * step: 1 = Verify identity, 2 = Preferences, 3 = Done
 */
const STEPS = ['Verify identity', 'Preferences', 'Done'];

export default function ProgressBar({ step }) {
    return (
        <div className="mb-4">
            <div className="flex gap-1.5 mb-1.5">
                {STEPS.map((_, i) => (
                    <div
                        key={i}
                        className="flex-1 h-0.5 rounded-full transition-colors duration-300"
                        style={{ background: i < step ? '#2ECC8E' : '#c5dff0' }}
                    />
                ))}
            </div>
            <div className="grid grid-cols-3 text-xs text-center" style={{ color: '#6b8fa8' }}>
                {STEPS.map((label, i) => (
                    <span
                        key={i}
                        style={{
                            color      : i + 1 === step ? '#2ECC8E' : i < step ? '#6b8fa8' : '#6b8fa8',
                            fontWeight : i + 1 === step ? 600 : 400
                        }}
                    >
                        {i < step - 1 ? `${label} ✓` : label}
                    </span>
                ))}
            </div>
        </div>
    );
}
